import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { ToastrModule } from 'ngx-toastr';
import { MatSelectModule } from '@angular/material/select';

import { SplashScreenModule } from './_shared/components/splash-screen/splash-screen.module';
import { LayoutModule } from './_shared/_layout/layout.module';
import { PageNotFoundModule } from './_shared/components/page-not-found/page-not-found.module';
import { AccessDeniedModule } from './_shared/components/access-denied/access-denied.module';

import { AuthService } from './account/core/services/auth.service';
import { ErrorHandlerService } from './_shared/core/services/error-handling.service';
import { AuthInterceptor } from './_shared/core/interceptors/auth.interceptor';
import { ErrorInterceptor } from './_shared/core/interceptors/error.interceptor';
import { CookieService } from 'ngx-cookie-service';
import { ImpersonationService } from './account/core/services/impersonation.service';

import { ActivatedRoute } from '@angular/router';
import { FullscreenOverlayContainer, OverlayContainer } from '@angular/cdk/overlay';

import { ExportIncidentService } from './account/core/services/export-incident.service';
import { ExportIncidentReportsService } from './account/core/services/export-incident-reports.service';

import { CoachMarkService } from './account/core/services/coach-mark.service';
import { MsalService, MSAL_INSTANCE } from '@azure/msal-angular';
import { MsalInstanceFactory } from './_shared/factory/msal-factory';

function appInitializer(route: ActivatedRoute, authService: AuthService, impersonationService: ImpersonationService, coachMarkService: CoachMarkService) {
  return () => {
    let params = new URLSearchParams(document.location.search.replace("?",''));
    let impersonationToken = params.get('impersonationToken');
    if (impersonationToken) {
      return new Promise((resolve) => {
        authService.currentTenantIdValue = +params.get('tenantId');
        impersonationService.impersonatedLogin(impersonationToken).subscribe(resolve);
      });
    }
    else {
      return new Promise((resolve) => {
        authService.getUser().subscribe({
          next: (userData) => {
            resolve(userData);
          },
          error: (error: any) => {
            resolve(error);
          }
        });
        if (authService.isAuthenticated) {
          coachMarkService.getAllCoachMarks().subscribe();
        }
      });
    }
  };
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SplashScreenModule,
    LayoutModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      extendedTimeOut: 1000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true
    }), 
    AppRoutingModule,
    PageNotFoundModule,
    AccessDeniedModule,
    HttpClientModule,
    MatSelectModule,
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializer,
      multi: true,
      deps: [ActivatedRoute, AuthService, ImpersonationService, CoachMarkService, ExportIncidentService, ExportIncidentReportsService],
    },
    { provide: ErrorHandler, useClass: ErrorHandlerService },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: OverlayContainer, useClass: FullscreenOverlayContainer },
    CookieService,
    {
      provide: MSAL_INSTANCE,
      useFactory: MsalInstanceFactory
  },
  MsalService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
